/**
 * Client-side mirror of the backend's NormalizeNPWP, used only to show the
 * user what will be stored before they save. The server normalises again.
 *
 *   15 digits  -> "0" + digits (legacy NPWP)
 *   16 digits  -> as is
 *   22 digits  -> first 16 (NITKU form CEISA writes back)
 *   anything else -> invalid
 */
export interface NpwpNormalization {
  /** Digits only, punctuation stripped. */
  digits: string;
  /** 16-digit form, or null when the input cannot be an NPWP. */
  normalized: string | null;
}

export const normalizeNpwp = (input: string): NpwpNormalization => {
  const digits = (input ?? '').replace(/\D/g, '');
  if (digits.length === 16) return { digits, normalized: digits };
  if (digits.length === 15) return { digits, normalized: `0${digits}` };
  if (digits.length === 22) return { digits, normalized: digits.slice(0, 16) };
  return { digits, normalized: null };
};

export const isValidNib = (input: string): boolean => {
  const trimmed = (input ?? '').replace(/\s/g, '');
  return trimmed === '' || /^\d{13}$/.test(trimmed);
};
